module.exports = __webpack_public_path__ + "static/media/slideHome.da1e933d.png";